module.exports = __webpack_public_path__ + "img/video.94b7b254.svg";